
import Vue from 'vue'
import BreadcrumbComponent from '@/components/Breadcrumb.vue'

export default Vue.extend({
   name: 'AdministrationBreadcrumbComponent',
   props: {
      crumbs: { type: Array as () => Breadcrumb[], default: () => [] },
   },
   computed: {
      userIsiUgoAdmin(): boolean {
         return this.$store.getters.userIsiUgoAdmin
      },
      expandedCrumbs(): Breadcrumb[] {
         const crumbs = []
         if (!this.containsCrumb('Administration')) {
            crumbs.push({ text: 'Administration', url: '/Administration/AdminHome/' })
         }
         crumbs.push(...this.crumbs)
         return crumbs
      },
   },
   methods: {
      containsCrumb(text: string) {
         const match = this.crumbs.find(c => c.text === text)
         return !!match
      },
      containsRoute(route: string) {
         const match = this.crumbs.find(c => c.route === route)
         return !!match
      },
   },
   components: {
      Breadcrumb: BreadcrumbComponent,
   },
})
